import { useLogout } from '@/auth/hooks/use-logout.mutation';
import { classList } from '@/helpers/class-list';
import { useSidebars } from '@/hooks/use-sidebars';

import { useSwitchAccount } from '@/auth/hooks/use-switch-account.mutation';
import { DropdownAccounts } from './dropdowns/dropdown-accounts/dropdown-accounts';
import { DropdownSettings } from './dropdowns/dropdown-settings';
import { TooltipDropdownCreate } from './dropdowns/tooltip-dropdown-create';
import { Logo } from './logo';
import {
  NavContainer,
  NavMenuContainer,
  NavSeparator,
  NavToggle,
} from './navbar.styles';
import { NavMenu } from './navmenu';
import { Stack } from '@/ui/line/line';

export const Navbar = () => {
  const logout = useLogout();
  const { isNavbarOpen, toggleNavbar } = useSidebars();
  const { mutateAsync: switchAccount } = useSwitchAccount();

  return (
    <NavContainer
      name="app-sidebar"
      direction="column"
      justify="space-between"
      padding="19px 14px 30px 14px"
      className={classList(isNavbarOpen && 'is-open')}
    >
      <Stack gap="50px">
        <Logo />
        <NavMenu />
      </Stack>
      <div>
        <NavMenuContainer>
          <TooltipDropdownCreate />
          <DropdownSettings onLogout={logout} />
          <DropdownAccounts onAccountSwitch={switchAccount} />
        </NavMenuContainer>
        <NavSeparator />
        <NavToggle
          data-testid="nav-toggle"
          icon="NaviChevron"
          onClick={toggleNavbar}
        />
      </div>
    </NavContainer>
  );
};
